import {
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  RESET_RESET_PASSWORD_STATE,
} from "../../actionTypes/resetPassword";

interface resetPasswordParams {
  emailOrPhone: string;
  newPassword: string;
  confirmPassword: string;
}

export const resetPasswordRequest = (payload: resetPasswordParams) => ({
  type: RESET_PASSWORD_REQUEST,
  payload,
});

export const resetPasswordSuccess = (data: string) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: data,
});

export const resetPasswordFailure = (error: string) => ({
  type: RESET_PASSWORD_FAILURE,
  payload: error,
});

export const resetPasswordResetState = () => ({
  type: RESET_RESET_PASSWORD_STATE,
});
